import TEMPLATE_URL from "emun.salesrep/territory-manager/zipcode/picker/zipcode-picker.htm";
import controller from "emun.salesrep/territory-manager/zipcode/picker/zipcode-picker.controller";
import open from "webmodals/open";

const NOOP = () => { };

export default ({
	size = "lg",
	backdrop = "static",
	templateUrl = TEMPLATE_URL,
	placement = undefined, // "right",
	title = "Select zipcodes(s)...",
	subTitle = "",
	view = "table",
	single = false,
	viewSelections = false,
	okButtonText = "OK",
	closeButtonText = single ? "Close" : "Cancel",
	selected = {},
	criteria = {},
	onToggle = NOOP,
	onZipcodeSelected = NOOP,
	onZipcodeDeselected = NOOP
} = {}) =>
	open({
		size,
		backdrop,
		templateUrl,
		console: console.debug(templateUrl, {
			placement,
			size,
			backdrop,
			title,
			view
		}),
		placement,
		controller,
		bindToController: true,
		controllerAs: "$ctrl",
		resolve: {
			options: () => ({
				title,
				subTitle,
				onZipcodeSelected,
				onZipcodeDeselected,
				onToggle,
				criteria,
				view,
				viewSelections,
				okButtonText,
				closeButtonText,
				single,
				selected
			})
		}
	}).result;
